    // -----------------------------
    // Highlighting Elements Section
    // -----------------------------
    function highlightElement(element, divToHighlight) {
        console.log(element);
        console.log(divToHighlight);

        // Remove existing highlights from letters and brands_wrapper divs
        document.querySelectorAll('.navigation_letter, .brands_wrapper').forEach(function (el) {
            el.classList.remove('highlight');
        });

        // Add highlight class to the clicked navigation letter
        element.classList.add('highlight');

        // Add highlight class to the corresponding brands_wrapper div
        if (divToHighlight) {
            divToHighlight.classList.add('highlight');
        }

        // Set a timeout to remove the highlights after 2 seconds
        setTimeout(function() {
            element.classList.remove('highlight');
            if (divToHighlight) {
                divToHighlight.classList.remove('highlight');
            }
        }, 2000); // 2000 milliseconds = 2 seconds
    }

    // -----------------------------
    // Scrolling and Navigation Section
    // -----------------------------
    function scrollToLetter(letter) {
        var element = document.getElementById('brand_' + letter);
        if (element) {
            var offset = window.innerWidth <= 769 ? 62 : 126; // 62px for mobile, 126px for desktop
            var elementPosition = element.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: elementPosition, behavior: 'smooth' });
            highlightElement(element.querySelector('.alphabet')); // Highlight the corresponding <h6> element
        }
    }

    var navigationLetters = document.querySelectorAll('.navigation_letter');
    navigationLetters.forEach(function (navLetter) {
        navLetter.addEventListener('click', function () {
            var letter = this.getAttribute('data-letter');
            scrollToLetter(letter);
            highlightElement(this); // Highlight the clicked navigation letter
        });
    });

    // -----------------------------
    // Search and Visibility Management Section
    // -----------------------------
    function updateBrandsWrapperVisibility() {
        var brandsWrappers = document.querySelectorAll('.brands_wrapper');

        brandsWrappers.forEach(function(wrapper) {
            var visibleItems = wrapper.querySelectorAll('.brands_list li:not([style*="display: none"])');
            wrapper.style.display = visibleItems.length === 0 ? 'none' : 'flex'; // Hide the wrapper if no visible items are found
        });
    }

    var searchInput = document.querySelector('.brand-search__wrapper input');

    function handleSearch() {
        var searchValue = searchInput.value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        var brandsList = document.querySelectorAll('.brands_list li');
    
        brandsList.forEach(function (brand) {
            var brandName = brand.textContent.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            brand.style.display = brandName.includes(searchValue) ? 'flex' : 'none'; // Show or hide the brand based on search
        });
        updateBrandsWrapperVisibility(); // Update visibility of brands_wrapper based on search results
    }
    

    searchInput.addEventListener('input', handleSearch); // Attach event listener for search input

    // -----------------------------
    // Scroll to Top Functionality
    // -----------------------------
    
    var scrollUpButton = document.getElementById('scrollUpButton');
    scrollUpButton.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    document.getElementById('clearInput').addEventListener('click', function() {
        document.getElementById('brandSearchInput').value = '';
        document.getElementById('brandSearchInput').focus(); // Optionally, focus the input after clearing
        handleSearch(); // Call your search handling function to update results
    });
    